import { useLocation, Navigate } from 'react-router-dom';
import ClusterPage from '../../../components/cluster/ClusterPage';
import { getContentSpoke, bc } from './registry';

export const metadata = {
  title: 'Florida AI Marketing Experts - Marketing Services',
  description: 'Expert marketing services by Florida AI Marketing Experts. Get in touch with us to learn more.',
  keywords: 'marketing services, Florida AI Marketing Experts',
  alternates: { canonical: 'https://floridaaimarketingexperts.com/cluster/content' },
};

export default function ContentSpokePage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+/, '').replace(/\/+$/, '');
  const s = slug ? getContentSpoke(slug) : undefined;
  if (!s) return <Navigate to="/chatgpt-ads-south-florida-home-services" replace />;

  return (
    <ClusterPage
      key={s.slug}
      slug={s.slug}
      keyword={s.keyword}
      title={s.title}
      h1={s.h1}
      eyebrow={s.eyebrow}
      leadAnswer={s.leadAnswer}
      metaDescription={s.metaDescription}
      keywords={s.keywords}
      areaServed={s.areaServed}
      serviceName={s.serviceName}
      serviceDescription={s.serviceDescription}
      faqs={s.faqs}
      breadcrumb={bc(s.h1, s.slug)}
      upLinks={s.upLinks}
      crossLinks={s.crossLinks}
    >
      {s.body}
    </ClusterPage>
  );
}
